import React, { useState } from 'react';
import Layout from '../../Layout/Layout'
import { Bars4Icon, BoltIcon, KeyIcon, MinusIcon, PlusIcon, SparklesIcon } from '@heroicons/react/24/solid'
import { ReactSortable } from "react-sortablejs";

const sortableOptions = {
    animation: 150,
    fallbackOnBody: true,
    swapThreshold: 0.65,
    ghostClass: "ghost",
    group: "shared", // Allows dragging between columns
    forceFallback: true
  };
  
  const HeaderShort = ({ title, list, setList }) => {
    const [showMinWarning, setShowMinWarning] = useState(false);
  
    const handleAdd = () => {
      setList(prevList => [
        ...prevList,
        { id: Date.now(), content: "", type: "text" }
      ]);
    };
  
    const handleRemove = (id) => {
      setList(prevList => {
        if (prevList.length <= 3) {
          setShowMinWarning(true);
          setTimeout(() => setShowMinWarning(false), 3000); // hide after 3s
          return prevList;
        }
        return prevList.filter(block => block.id !== id);
      });
    };
  
    const handleChange = (id, value) => {
      setList(prevList =>
        prevList.map(block =>
          block.id === id ? { ...block, content: value } : block
        )
      );
    };
  
    return (
      <div className="column space-y-2">
        <ReactSortable list={list} setList={setList} {...sortableOptions}>
          {list.map((block, index) => (
            <HeaderBlock
              key={block.id}
              block={block}
              isLast={index === list.length - 1}
              onAdd={handleAdd}
              onRemove={() => handleRemove(block.id)}
              onChange={(value) => handleChange(block.id, value)}
            />
          ))}
        </ReactSortable>
        {showMinWarning && (
          <div className="text-xs text-red-600 bg-red-100 border border-red-300 px-3 py-3.5 rounded-md">
            Minimum 3 subheadings required.
          </div>
        )}
      </div>
    );
  };
  
  
  
  const HeaderBlock = ({ block, isLast, onAdd, onRemove, onChange }) => {
    if (!block) return null;
  
    return (
      <>
        <div className="my-2 flex justify-between items-center cursor-grab sortable">
            <Bars4Icon aria-hidden="true" className="h-4 w-4 text-gray-400 me-2" />
            <div className='relative w-full'>
            <input
                id="keyword"
                name="keyword"
                type="text"
                value={block.content}
                placeholder="Subheadings"
                onChange={(e) => onChange(e.target.value)}
                className="col-start-1 row-start-1 block w-full rounded-md bg-white py-2.5 pl-3 pr-3 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-1 focus:-outline-offset-1 focus:outline-red-600 sm:pl-4 sm:text-sm/6"
            />
            <div className='absolute mt-[1px] top-0 right-4 h-10 flex items-center justify-center gap-2'>
                {isLast ? (
                <>
                    <button type="button" onClick={onAdd} className="text-slate-400 hover:text-slate-600">
                    <PlusIcon aria-hidden="true" className="size-4" />
                    </button>
                    <button type="button" onClick={onRemove} className="text-slate-400 hover:text-slate-600">
                    <MinusIcon aria-hidden="true" className="size-4" />
                    </button>
                </>
                ) : (
                <button type="button" onClick={onRemove} className="text-slate-400 hover:text-slate-600">
                    <MinusIcon aria-hidden="true" className="size-4" />
                </button>
                )}
            </div>
            </div>
        </div>
      </>
    );
  };
  
  

function AddArticle() {
    const [outlineList, setOutlineList] = useState([
        { id: 1, content: "Introduction to Baisakhi Festival", type: "text" },
        { id: 2, content: "Traditional Attire for Men and Women", type: "text" },
        { id: 3, content: "Modern Twist on Baisakhi Outfits", type: "text" },
        { id: 4, content: "Accessories to Complete the Look", type: "text" },
        { id: 5, content: "Dressing Etiquette for Baisakhi Celebrations", type: "text" },
        { id: 6, content: "Where to Find Authentic Baisakhi Outfits", type: "text" },
        { id: 7, content: "Conclusion: Celebrate Baisakhi in Style", type: "text" },
    ]);
    return (
        <Layout>
            <div className="px-4 sm:px-6 lg:px-0 max-w-2xl mx-auto py-10">
                <h1 className="text-4xl font-bold text-gray-900 text-center py-2 flex items-center justify-center">Generate Articles With <SparklesIcon aria-hidden="true" className="-ml-0.5 size-9 ms-1 me-1 text-purple-600" /> Ai</h1>
                <p className="text-sm text-slate-600 text-center">Turn a title and outline into a long and engaging article.</p>
                <div className="bg-white shadow-2xl rounded-2xl p-10 my-6">
                    <div className='mb-4'>
                        <label htmlFor="title" className="block text-sm/6 font-semibold text-slate-600">
                            Article title *
                        </label>
                        <div className="mt-2 grid grid-cols-1">
                            <input
                                id="title"
                                name="title"
                                type="text"
                                value="Dress For Baisakhi Festival"
                                placeholder="e.g. The 15 Best Places to Live in the India in 2025"
                                className="col-start-1 row-start-1 block w-full rounded-md bg-white py-2.5 pl-10 pr-3 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-1 focus:-outline-offset-1 focus:outline-red-600 sm:pl-9 sm:text-sm/6"
                            />
                            <SparklesIcon
                                aria-hidden="true"
                                className="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-gray-400 sm:size-4"
                            />
                        </div>
                    </div>
                    <div className='mb-4'>
                        <label htmlFor="keyword" className="block text-sm/6 font-semibold text-slate-600">
                            Focus Keywords <small className='text-slate-400 font-medium'>separated with a comma</small>
                        </label>
                        <div className="mt-2 grid grid-cols-1">
                            <input
                                id="keyword"
                                name="keyword"
                                type="text"
                                placeholder="Add Keywords"
                                className="col-start-1 row-start-1 block w-full rounded-md bg-white py-2.5 pl-10 pr-3 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-1 focus:-outline-offset-1 focus:outline-red-600 sm:pl-9 sm:text-sm/6"
                            />
                            <KeyIcon
                                aria-hidden="true"
                                className="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-gray-400 sm:size-4"
                            />
                        </div>
                    </div>
                    <div className='mb-4'>
                        <div className='flex items-center justify-between'>
                            <label className="block text-sm/6 font-semibold text-slate-600">
                                Outline * <small className='text-slate-400 font-medium'>minimum 3 subheadings</small>
                            </label>
                            <button type="button" className="inline-flex items-center rounded-md text-white bg-gray-800 hover:bg-gray-900 px-3 py-2 text-xs font-semibold shadow-sm" >
                                <BoltIcon aria-hidden="true" className="size-4 me-1" />
                                Write the outline with Ai
                            </button>
                        </div>
                        <div className="mt-2">
                            <HeaderShort title="Right Column" list={outlineList} setList={setOutlineList} />
                        </div>
                    </div>
                </div>
                <div className='flex items-center justify-center py-4'>
                    <a href='/ai-article/article-generator' class="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-bold rounded-lg text-sm px-10 py-3.5 text-center me-2 mb-2 inline-flex items-center shadow-lg hover:shadow-2xl"><SparklesIcon aria-hidden="true" className="me-1 size-5" /> Write Article</a>
                </div>
            </div>
        </Layout>
    )
}

export default AddArticle
